import { useEffect } from 'react'
import { IntlProvider } from 'react-intl'
import { useSelector } from 'react-redux'
import moment from 'moment'

import 'moment/locale/cs'
import 'moment/locale/en-gb'

import { flattenMessages } from './helpers'

import messages from './messages'

const I18nProvider = (props) => {
    const locale = useSelector((state) => state.i18n.locale)

    useEffect(() => {
        moment.locale(locale === 'en' ? 'en-gb' : locale)
    }, [locale])

    return (
        <IntlProvider messages={flattenMessages(messages[locale])} locale={locale} defaultLocale={'cs'}>
            {props.children}
        </IntlProvider>
    )
}

export default I18nProvider
